/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import dayjs from "dayjs";
import { Cell } from "react-table";
import { format } from "timeago.js";
import { Text } from "@nordcloud/gnui";
import { NotificationIcon, NOTIFICATION_ICON_STATUS } from "~/components/Icons";
import { dateFormat } from "~/constants";

type TitleProps = {
  isRead: boolean;
  title: string;
};

function Title({ isRead, title }: TitleProps) {
  return isRead ? (
    <Text tag="span">{title}</Text>
  ) : (
    <Text tag="span" weight="bold">
      {title}
    </Text>
  );
}

type Notification = {
  id: string;
  type: NOTIFICATION_ICON_STATUS;
  title: string;
  details: string;
  targetView: string;
  read: boolean;
  createdAt: string;
};

export const NotificationListColumns = () => [
  {
    Header: "",
    accessor: "type",
    disableSortBy: true,
    Cell: ({ row }: Cell<Notification>) => {
      return <NotificationIcon type={row.original.type} />;
    },
    width: 1,
  },
  {
    Header: "",
    accessor: "title",
    disableSortBy: true,
    Cell: ({ row }: Cell<Notification>) => {
      const isRead = row?.original?.read;

      return <Title isRead={isRead} title={row?.original?.title} />;
    },

    width: 500,
  },
  {
    Header: "Date",
    Cell: ({ row }: Cell<Notification>) => {
      const date = row?.original?.createdAt;
      return dayjs(date).format(`${dateFormat.dayMonthYear}`);
    },
    width: 100,
  },
  {
    Header: "Time",
    Cell: ({ row }: Cell<Notification>) => {
      const date = row?.original?.createdAt;
      return format(date);
    },
    width: 100,
  },
];
